(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nx-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('.nx-shipping-bar[data-section-id]');
    if (!bar) return;

    var thresholdCents = parseInt(bar.dataset.thresholdCents, 10) || 6500;
    var labelToGo = bar.dataset.labelToGo;
    var labelUnlocked = bar.dataset.labelUnlocked;
    var labelEmpty = bar.dataset.labelEmpty;

    var textEl = bar.querySelector('[data-shipping-text]');
    var amountEl = bar.querySelector('[data-shipping-amount]');
    var fillEl = bar.querySelector('[data-shipping-fill]');
    var trackEl = bar.querySelector('[data-shipping-track]');

    function formatEur(cents) {
      var euros = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + euros;
    }

    function thresholdEur() {
      return '€' + Math.floor(thresholdCents / 100);
    }

    function render(totalCents) {
      var total = totalCents || 0;
      var pct = Math.min(100, (total / thresholdCents) * 100);
      var remaining = Math.max(0, thresholdCents - total);

      fillEl.style.width = pct.toFixed(1) + '%';
      trackEl.setAttribute('aria-valuenow', Math.round(pct));

      if (total === 0) {
        // Empty cart
        textEl.innerHTML = labelEmpty + ' <strong>' + thresholdEur() + '</strong>';
        amountEl.textContent = '';
        bar.classList.remove('is-unlocked');
      } else if (total >= thresholdCents) {
        // Unlocked
        textEl.textContent = labelUnlocked;
        amountEl.textContent = '';
        bar.classList.add('is-unlocked');
      } else {
        // To-go state
        textEl.innerHTML = 'Nog <strong>' + formatEur(remaining) + '</strong> ' + labelToGo;
        amountEl.textContent = formatEur(total) + ' / ' + thresholdEur();
        bar.classList.remove('is-unlocked');
      }
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) { render(cart.total_price || 0); })
        .catch(function() { /* fail silent */ });
    }

    // Initial fetch
    fetchCart();

    // Re-fetch when cart changes (Snow dispatches custom events)
    var events = ['cart:updated', 'cart:refresh', 'cart:item-added', 'cart:change'];
    events.forEach(function(evt) {
      document.addEventListener(evt, fetchCart);
    });

    // Fallback: poll cart on fetch interception (catches Snow's native cart-add)
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function() {
        var args = arguments;
        var url = (args[0] && args[0].url) || args[0] || '';
        var isCartMutation = typeof url === 'string' &&
          (url.indexOf('/cart/add') !== -1 ||
           url.indexOf('/cart/change') !== -1 ||
           url.indexOf('/cart/update') !== -1 ||
           url.indexOf('/cart/clear') !== -1);
        return originalFetch.apply(this, args).then(function(response) {
          if (isCartMutation && response.ok) {
            setTimeout(fetchCart, 100);
          }
          return response;
        });
      };
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function activate(section, index) {
      if (!section) return;
      section.querySelectorAll('.nx-tabs__tab').forEach(function(tab) {
        var on = tab.dataset.tab === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      section.querySelectorAll('.nx-tabs__panel').forEach(function(panel) {
        var on = panel.dataset.panel === String(index);
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }

    // Delegated click — werkt voor elke nx-tabs, ook na re-render in de theme editor
    document.addEventListener('click', function(e) {
      var tab = e.target.closest('.nx-tabs__tab');
      if (!tab) return;
      activate(tab.closest('.nx-tabs'), tab.dataset.tab);
    });

    // Keyboard pijltjes (ARIA tabs pattern)
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tab = e.target.closest('.nx-tabs__tab');
      if (!tab) return;
      var section = tab.closest('.nx-tabs');
      var arr = Array.prototype.slice.call(section.querySelectorAll('.nx-tabs__tab'));
      var i = arr.indexOf(tab);
      var n = e.key === 'ArrowRight' ? (i + 1) % arr.length : (i - 1 + arr.length) % arr.length;
      e.preventDefault();
      activate(section, arr[n].dataset.tab);
      arr[n].focus();
    });

    // Deep-link ?tab=2 → opent juiste tab op alle nx-tabs
    function deepLink() {
      var t = new URLSearchParams(window.location.search).get('tab');
      if (t && ['1','2','3'].indexOf(t) !== -1) {
        document.querySelectorAll('.nx-tabs').forEach(function(s) { activate(s, t); });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deepLink);
    else deepLink();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var STORAGE_KEY = 'nx_recently_viewed';
    var section = document.querySelector('.nx-recently-viewed[data-section-id]');
    if (!section) return;

    var maxItems = parseInt(section.dataset.maxItems, 10) || 6;
    var grid = section.querySelector('[data-nx-rv-grid]');

    function readList() {
      try {
        var v = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(v) ? v : [];
      } catch (e) { return []; }
    }

    function writeList(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 20))); }
      catch (e) {}
    }

    // === Track: als we op product-page zijn, add to recently viewed ===
    function trackCurrent() {
      var path = window.location.pathname;
      var match = path.match(/^\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = match[1];

      var list = readList();
      list = list.filter(function(h){ return h !== handle; }); // remove duplicate
      list.unshift(handle);
      writeList(list);
    }
    trackCurrent();

    // === Render ===
    function fetchProduct(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(r){ if (!r.ok) throw new Error('404'); return r.json(); })
        .catch(function(){ return null; });
    }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function render() {
      // Get list, exclude current page's product
      var path = window.location.pathname;
      var current = (path.match(/^\/products\/([^/?#]+)/) || [])[1];
      var list = readList().filter(function(h){ return h !== current; }).slice(0, maxItems);

      if (!list.length) {
        section.hidden = true;
        return;
      }

      Promise.all(list.map(fetchProduct)).then(function(products) {
        var valid = products.filter(Boolean);
        if (!valid.length) {
          section.hidden = true;
          return;
        }
        section.hidden = false;
        grid.innerHTML = '';
        valid.forEach(function(p) {
          var card = document.createElement('a');
          card.className = 'nx-rv-card';
          card.href = p.url;
          var img = (p.featured_image || p.images[0] || '');
          card.innerHTML =
            '<div class="nx-rv-card__media">' +
              '<img src="' + img + '" alt="' + p.title + '" loading="lazy" decoding="async">' +
            '</div>' +
            '<div class="nx-rv-card__body">' +
              '<h3 class="nx-rv-card__name">' + p.title + '</h3>' +
              '<p class="nx-rv-card__price">' + formatMoney(p.price) +
                (p.available === false ? '<span class="nx-rv-card__oos">Uitverkocht</span>' : '') +
              '</p>' +
            '</div>';
          grid.appendChild(card);
        });
      });
    }

    // Render initially (slight delay to ensure current product is tracked first)
    setTimeout(render, 50);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.nx-related[data-section-id]');
    if (!section) return;

    var productId = section.dataset.productId;
    var intent = section.dataset.intent || 'related';
    var limit = parseInt(section.dataset.limit, 10) || 10;
    var grid = section.querySelector('[data-nx-related-grid]');

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function extractColorName(title) {
      // Try " – " then " - " as separator
      var parts = title.split(' – ');
      if (parts.length === 1) parts = title.split(' - ');
      return parts.length > 1 ? parts[parts.length - 1] : '';
    }

    function calcDiscount(price, compare) {
      if (!compare || compare <= price) return 0;
      return Math.round(((compare - price) / compare) * 100);
    }

    function renderCard(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var inWishlist = window.NXWishlist && window.NXWishlist.has(p.handle);
      var color = extractColorName(p.title);
      var nameMain = color ? p.title.split(' – ')[0].split(' - ')[0] : p.title;
      var discount = calcDiscount(p.price, p.compare_at_price);

      var html =
        '<a class="nx-rp-card" href="' + p.url + '">' +
          '<div class="nx-rp-card__media">' +
            (discount > 0 ? '<span class="nx-rp-card__sale">-' + discount + '%</span>' : '') +
            '<button class="nx-rp-card__heart" type="button" ' +
              'data-nx-wishlist-toggle data-handle="' + p.handle + '" data-title="' + escapeHtml(p.title) + '" ' +
              'aria-label="Toggle wishlist voor ' + escapeHtml(p.title) + '" ' +
              'aria-pressed="' + (inWishlist ? 'true' : 'false') + '" ' +
              'onclick="event.preventDefault(); event.stopPropagation();">' +
              '<svg class="nx-rp-heart-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
                '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
              '</svg>' +
              '<svg class="nx-rp-heart-fill" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
                '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
              '</svg>' +
            '</button>' +
            '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" decoding="async">' +
            (p.available === false ? '<span class="nx-rp-card__oos">Uitverkocht</span>' : '') +
          '</div>' +
          '<div class="nx-rp-card__body">' +
            '<h3 class="nx-rp-card__name">' + escapeHtml(nameMain) + '</h3>' +
            (color ? '<p class="nx-rp-card__color">' + escapeHtml(color) + '</p>' : '') +
            '<p class="nx-rp-card__price">' + formatMoney(p.price) +
              (discount > 0 ? '<span class="nx-rp-card__compare">' + formatMoney(p.compare_at_price) + '</span>' : '') +
            '</p>' +
          '</div>' +
        '</a>';
      return html;
    }

    function fetchRecommendations() {
      var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
      fetch(url)
        .then(function(r) { if (!r.ok) throw new Error('fail'); return r.json(); })
        .then(function(data) {
          var products = (data.products || []).filter(function(p){ return p.handle; });
          if (!products.length) return;
          section.hidden = false;
          grid.innerHTML = products.map(renderCard).join('');
          // Manually trigger wishlist sync for new buttons
          if (window.NXWishlist) {
            // The MutationObserver in nx-wishlist-core will pick these up automatically.
          }
        })
        .catch(function() { /* hidden stays */ });
    }

    fetchRecommendations();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-sticky-atc-mobile"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const bar = document.querySelector('.nx-sticky-atc[data-section-id]');
    if (!bar) return;
    if (window.matchMedia('(min-width: 769px)').matches) return;

    // Find main product form ATC button (Snow uses product-form custom element)
    const mainAtc =
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('[data-product-form] button[type="submit"]');

    const stickyTrigger = bar.querySelector('[data-nx-sticky-atc-trigger]');

    if (stickyTrigger && mainAtc) {
      stickyTrigger.addEventListener('click', () => {
        // Scroll to main form als variant niet selected, anders direct click
        const requiresVariantSelect = document.querySelector('variant-radios:not([data-has-selection])');
        if (requiresVariantSelect) {
          requiresVariantSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainAtc.click();
      });
    }

    // Toon sticky bar zodra user voorbij main ATC scrollt
    if (mainAtc && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px -100px 0px'
      });
      observer.observe(mainAtc);
    } else {
      // Fallback: altijd zichtbaar
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-wishlist-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.nx-wishlist[data-section-id]');
    if (!section) return;
    if (!window.NXWishlist) return; // core not loaded

    var grid = section.querySelector('[data-nx-wishlist-grid]');
    var emptyState = section.querySelector('[data-nx-wishlist-empty-state]');
    var countText = section.querySelector('[data-nx-wishlist-count-text]');
    var emptyText = section.querySelector('[data-nx-wishlist-empty-text]');
    var countNum = section.querySelector('[data-nx-wishlist-count]');

    function fetchProduct(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(r) { if (!r.ok) throw new Error('404'); return r.json(); })
        .catch(function() { return null; });
    }

    function formatMoney(cents) {
      var euros = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + euros;
    }

    function render(handles) {
      if (!handles.length) {
        grid.hidden = true;
        emptyState.hidden = false;
        if (emptyText) emptyText.hidden = false;
        if (countText) countText.hidden = true;
        return;
      }

      grid.hidden = false;
      emptyState.hidden = true;
      if (emptyText) emptyText.hidden = true;
      if (countText) {
        countText.hidden = false;
        if (countNum) countNum.textContent = handles.length;
      }

      grid.innerHTML = '<p style="grid-column: 1/-1; font-size:13px; color:#6b6b6b;">Laden…</p>';

      Promise.all(handles.map(fetchProduct)).then(function(products) {
        grid.innerHTML = '';
        products.forEach(function(p, idx) {
          if (!p) return;
          var card = document.createElement('div');
          card.className = 'nx-wl-card';
          var img = (p.featured_image || p.images[0] || '');
          card.innerHTML =
            '<a class="nx-wl-card__media" href="' + p.url + '">' +
              '<img src="' + img + '" alt="' + p.title + '" loading="lazy" decoding="async">' +
            '</a>' +
            '<button class="nx-wl-card__remove" type="button" data-remove="' + p.handle + '" aria-label="Verwijder uit wishlist">' +
              '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 2l10 10M12 2L2 12" stroke-linecap="square"/></svg>' +
            '</button>' +
            '<a class="nx-wl-card__body" href="' + p.url + '">' +
              '<h3 class="nx-wl-card__name">' + p.title + '</h3>' +
              '<p class="nx-wl-card__price">' + formatMoney(p.price) + '</p>' +
              (p.available === false ? '<span class="nx-wl-card__oos">Uitverkocht</span>' : '') +
            '</a>';
          grid.appendChild(card);
        });
      });
    }

    // Remove handler (event delegation)
    grid.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-remove');
      window.NXWishlist.remove(handle);
    });

    // Initial render
    render(window.NXWishlist.get());

    // Re-render on changes
    document.addEventListener('nx:wishlist:change', function(e) {
      render(e.detail.handles);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
